// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__6fCpo","buttons":"PendingPaymentAlert_buttons__1gYYP"};